export class UnderwritingSettingsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getUnderwritingSettings() {
    return this.#http.get(`/UnderwritingSettings`);
  }

  async editUnderwritingSettings({ settingName, ...body }) {
    return this.#http.put(`/UnderwritingSettings/${settingName}`, body);
  }
}
